import { seismicZoneLegendPerLevel } from "../legends/seismic/SeismicClassificationITALegend";
import { snow5CMLegendLegendPerLevel, snow5CMLegendLegendLevels } from "../legends/Snow5CMLegend";
import { hailITALargeLegendPerLevel, hailITALargeLegendLevels } from "../legends/HailITALargeLegend";
import { lightningStrikeLegendPerLevel, lightningStrikeLegendLevels } from "../legends/LightningStrikeLegend";
import { flashFlood24hEULegendPerLevel, flashFlood24hEULegendLevels } from "../legends/FlashFlood24hEULegend";
import { climateIndexLevelNames, climateIndexLevels } from "../legends/ClimateIndexLegend";
import {
  highWindSevereITALegendPerLevel,
  highWindSevereITALegendLevels,
} from "../legends/HighWindSeverelTALegend";
import { itaAniaLevels, aniaIndexLevels } from "../legends/ItaAniaWindLegend";
import { ANIA_ENUM } from "../util/AniaEnums";
import { envelope } from "@turf/turf";

const configEnviroment = {
  realeRisk: { tivLow: 45000000, tivHigh: 90000000 },
  howden: { tivLow: 3000000, tivHigh: 10000000 },
}[process.env.REACT_APP_ENVIRONMENT];

// Experimental, it will change soon
export const bivariateKpiThresholds = (variantProp) => {
  return {
    dbb_no_policies: {
      min: 1,
      low2Moderate: 30,
      moderate2High: 200,
      max: 700,
      increase: true,
    },

    none: {
      min: 1,
      low2Moderate: 1e9,
      moderate2High: 1e9,
      max: 1e9,
      increase: true,
    },

    policyNumber: {
      min: 1,
      low2Moderate: variantProp !== "AgroClimateAnalytics" ? 30 : 4,
      moderate2High: variantProp !== "AgroClimateAnalytics" ? 200 : 15,
      max: 700,
      increase: true,
    },
    accruedRisk: {
      min: 1,
      low2Moderate: 30,
      moderate2High: 200,
      max: 700,
      increase: true,
    },
    postrenewalValueFinal: {
      min: 1,
      low2Moderate: variantProp !== "AgroClimateAnalytics" ? configEnviroment.tivLow : 40000,
      moderate2High: variantProp !== "AgroClimateAnalytics" ? configEnviroment.tivHigh : 300000,
      max: 700,
      increase: true,
    },
    premiumNettoEur: {
      min: 1,
      low2Moderate: 2000,
      moderate2High: 15000,
      max: 700,
      increase: true,
    },
  };
};

export const riskLevelThresholdsAndLegends = (t) => {
  return {
    earthquake: {
      riskNames: [
        seismicZoneLegendPerLevel(t, 0),
        seismicZoneLegendPerLevel(t, 1),
        seismicZoneLegendPerLevel(t, 2),
        seismicZoneLegendPerLevel(t, 3),
        seismicZoneLegendPerLevel(t, 4),
      ],
      riskLevelValues: { strictStepValues: [0, 1, 2, 3, 4] },
    },
    snow: {
      riskNames: [
        snow5CMLegendLegendPerLevel(t, 0),
        snow5CMLegendLegendPerLevel(t, 1),
        snow5CMLegendLegendPerLevel(t, 2),
        snow5CMLegendLegendPerLevel(t, 3),
        snow5CMLegendLegendPerLevel(t, 4),
      ],
      riskLevelValues: { intervalBoundaries: snow5CMLegendLegendLevels() },
    },
    lightning: {
      riskNames: [
        lightningStrikeLegendPerLevel(t, 0),
        lightningStrikeLegendPerLevel(t, 1),
        lightningStrikeLegendPerLevel(t, 2),
        lightningStrikeLegendPerLevel(t, 3),
        lightningStrikeLegendPerLevel(t, 4),
        lightningStrikeLegendPerLevel(t, 5),
      ],
      riskLevelValues: { intervalBoundaries: lightningStrikeLegendLevels() },
    },
    hail: {
      riskNames: [
        hailITALargeLegendPerLevel(t, 0),
        hailITALargeLegendPerLevel(t, 1),
        hailITALargeLegendPerLevel(t, 2),
        hailITALargeLegendPerLevel(t, 3),
        hailITALargeLegendPerLevel(t, 4),
      ],
      riskLevelValues: { intervalBoundaries: hailITALargeLegendLevels() },
    },
    wind: {
      riskNames: [
        highWindSevereITALegendPerLevel(t, 0),
        highWindSevereITALegendPerLevel(t, 1),

        highWindSevereITALegendPerLevel(t, 2),
        highWindSevereITALegendPerLevel(t, 3),
        highWindSevereITALegendPerLevel(t, 4),
      ],
      riskLevelValues: { intervalBoundaries: highWindSevereITALegendLevels() },
    },
    rain: {
      riskNames: [
        flashFlood24hEULegendPerLevel(t, 0),
        flashFlood24hEULegendPerLevel(t, 1),
        flashFlood24hEULegendPerLevel(t, 2),
        flashFlood24hEULegendPerLevel(t, 3),
        flashFlood24hEULegendPerLevel(t, 4),
      ],
      riskLevelValues: { intervalBoundaries: flashFlood24hEULegendLevels() },
    },
    weatherindex: {
      riskNames: [
        `${t("levels.low")} : (pp < 0.5)`,
        `${t("levels.moderate")} : (0.5 ≤ pp < 1.5)`,
        `${t("levels.significant")} : (1.5 ≤ pp )`,
      ],
      riskLevelValues: { intervalBoundaries: [0.5, 1.5, 100] },
    },

    aniaWindstorm: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_01).aniaLegendLevel,
      riskLevelValues: { strictStepValues: [0, 1, 2, 3] },
    },
    aniaLightning: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_03).aniaLegendLevel,
      riskLevelValues: { strictStepValues: [0, 1, 2, 3] },
    },
    aniaPrecipitation: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_04).aniaLegendLevel,
      riskLevelValues: { strictStepValues: [0, 1, 2, 3] },
    },
    aniaHail: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_02).aniaLegendLevel,
      riskLevelValues: { strictStepValues: [0, 1, 2, 3] },
    },
    aniaSnow: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_05).aniaLegendLevel,
      riskLevelValues: { strictStepValues: [0, 1, 2, 3] },
    },

    aniaNcat: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_LEGEND).aniaLegendLevel,
      riskLevelValues: { intervalBoundaries: aniaIndexLevels },
    },
    aniaNat: {
      riskNames: itaAniaLevels(t, "", ANIA_ENUM.ANIA_LEGEND).aniaLegendLevel,
      riskLevelValues: { intervalBoundaries: aniaIndexLevels },
    },
    realeGroupWind: {
      riskNames: [1, 2, 3, 4, 5].map((i) => t("riskAssessment.Zone") + " " + i),
      riskLevelValues: { strictStepValues: [1, 2, 3, 4, 5] },
    },
    realeGroupHail: {
      riskNames: [1, 2, 3, 4, 5, 6].map((i) => t("riskAssessment.Zone") + " " + i),
      riskLevelValues: { strictStepValues: [1, 2, 3, 4, 5, 6] },
    },
    howdenWeightedInlandFlood202410: {
      riskNames: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(
        (i) => t("riskAssessment.Zone") + " " + Math.max(0, i - 0.5) + " - " + Math.min(10, i + 0.49),
      ),
      riskLevelValues: { intervalBoundaries: [0.5, 1.5, 2.5, 3.5, 4.5, 5.5, 6.5, 7.5, 8.5, 9.5, 10.5] },
    },

    cysNcat: {
      riskNames: climateIndexLevelNames(t),
      riskLevelValues: { intervalBoundaries: climateIndexLevels },
    },

    cysNat: {
      riskNames: climateIndexLevelNames(t),
      riskLevelValues: { intervalBoundaries: climateIndexLevels },
    },

    anyhazard: {
      riskNames: ["Hazard data exista"],
      riskLevelValues: { strictStepValues: [0] },
    },
  };
};

export const bivarianteHazardThresholds =
  // This table is used both for bivariate logic (always 3 levels) and for the risk levels (levels match the legend on the risk map).
  {
    earthquake: {
      min: 0,
      low2Moderate: 3.5,
      moderate2High: 2.5,
      max: 5,
      increase: false,
    },
    snow: {
      min: 0,
      low2Moderate: 20,
      moderate2High: 70,
      max: 100,
      increase: true,
    },
    lightning: {
      min: 0,
      low2Moderate: 8.5,
      moderate2High: 17,
      max: 100,
      increase: true,
    },
    hail: {
      min: 0,
      low2Moderate: 0.019,
      moderate2High: 0.039,
      max: 100,
      increase: true,
    },
    wind: {
      min: 0,
      low2Moderate: 0.36,
      moderate2High: 0.86,
      max: 100,
      increase: true,
    },
    rain: {
      min: 0,
      low2Moderate: 3.07,
      moderate2High: 4.84,
      max: 100,
      increase: true,
    },
    weatherindex: {
      min: 0,
      low2Moderate: 0.5,
      moderate2High: 1.5,
      max: 100,
      increase: true,
    },

    aniaWindstorm: {
      min: 0,
      low2Moderate: 1.5,
      moderate2High: 2.5,
      max: 4,
      increase: true,
    },
    aniaLightning: {
      min: 0,
      low2Moderate: 1.5,
      moderate2High: 2.5,
      max: 4,
      increase: true,
    },
    aniaPrecipitation: {
      min: 0,
      low2Moderate: 1.5,
      moderate2High: 2.5,
      max: 4,
      increase: true,
    },
    aniaHail: {
      min: 0,
      low2Moderate: 1.5,
      moderate2High: 2.5,
      max: 4,
      increase: true,
    },
    aniaSnow: {
      min: 0,
      low2Moderate: 1.5,
      moderate2High: 2.5,
      max: 4,
      increase: true,
    },

    realeGroupWind: {
      min: 0,
      low2Moderate: 2.5,
      moderate2High: 3.5,
      max: 5,
      increase: true,
    },
    realeGroupHail: {
      min: 0,
      low2Moderate: 2.5,
      moderate2High: 4.5,
      max: 6,
      increase: true,
    },
    howdenWeightedInlandFlood202410: {
      min: 0,
      low2Moderate: 1.5,
      moderate2High: 3.5,
      max: 10,
      increase: true,
    },

    aniaNcat: {
      min: 0,
      //low2Moderate: 2.25,
      //moderate2High: 3.75,
      //max: 6, // Matches three intervals: 1-2 2.5-3.5 4-5 in 5 level scale in all Geojson files.

      low2Moderate: 1.6,
      moderate2High: 2.4,
      max: 4, // Matches three intervals: 1-1.5 1.75-2.25 2.5-3 in 3 level scale in all Geojson files.

      increase: true,
    },

    aniaNat: {
      min: 0,
      //low2Moderate: 2.25,
      //moderate2High: 3.75,
      //max: 6, // Matches three intervals: 1-2 2.5-3.5 4-5 in 5 level scale in all Geojson files.

      low2Moderate: 1.6,
      moderate2High: 2.4,
      max: 4, // Matches three intervals: 1-1.5 1.75-2.25 2.5-3 in 3 level scale in all Geojson files.
      increase: true,
    },

    cysNcat: {
      min: -10,
      low2Moderate: 33,
      moderate2High: 66,
      max: 110,
      increase: true,
    },

    cysNat: {
      min: -10,
      low2Moderate: 33,
      moderate2High: 66,
      max: 110,
      increase: true,
    },

    anyhazard: {
      min: 0,
      low2Moderate: 10000, // hazard level is always 0, the map always shows the KPI only.
      moderate2High: 20000,
      max: 100000,
      increase: true,
    },
  };

export const getSubintervals = (KPISelect, hazardSelect, variantProp) => {
  if (!bivarianteHazardThresholds[hazardSelect]) {
    console.error(
      `getSubintervals: hazardSelect ${hazardSelect} not found in bivarianteHazardThresholds  `,
      bivarianteHazardThresholds,
    );
    return;
  }
  const subIntervalsObject = {
    kpi: {
      low: bivariateKpiThresholds(variantProp)[KPISelect].low2Moderate,
      high: bivariateKpiThresholds(variantProp)[KPISelect].moderate2High,
    },
    hazard: {
      low: bivarianteHazardThresholds[hazardSelect].low2Moderate,
      high: bivarianteHazardThresholds[hazardSelect].moderate2High,
    },
  };
  return subIntervalsObject;
  //const subIntervals = JSON.stringify(subIntervalsObject);
  //return subIntervals;
};

export const getSimplifiedFromAnia = (hazardSelect) => {
  const simplified = {
    aniaWindstorm: "wind",
    aniaLightning: "lightning",
    aniaPrecipitation: "rain", // meanining rain, pioggia in Version 3
    aniaHail: "hail",
    aniaSnow: "snow",
    weatherindex: "wind|hail",
    aniaNat: "wind|hail",
    cysNat: "wind|hail",
    aniaNcat: "wind|hail|snow|rain",
    cysNcat: "wind|hail|snow|rain",
    realeGroupWind: "wind",
    realeGroupHail: "hail",
    howdenWeightedInlandFlood202410: "inland_flood",
  };
  const returnVal = simplified[hazardSelect] ? simplified[hazardSelect] : hazardSelect;

  return returnVal;
};

export const mapHazardCodeToHazardProperty = {
  // These properties (cys_*,ania_*) must appear in s3://s3.amazonaws.com/cys-realerisk-mapdata/garanzia-peril/istat_comune_risk_values_2023.geojson
  // the bucket must be accessed through cloudfront https://d24ye0ax7gglwd.cloudfront.net
  // which is generated in code C:\dev\cys-realerisk-analytics-mapviews\notebooks\00_MapViewPrepareAdministrativeRisksMulti2.ipynb
  earthquake: "cys_risk_seismic",
  snow: "cys_risk_snow_5cm",
  hail: "cys_risk_hail",
  lightning: "cys_risk_lightning",
  wind: "cys_risk_windstorm",
  rain: "cys_risk_flashflood", // meanining rain, pioggia in Version 3
  aniaWindstorm: "ania_windstorm",
  aniaLightning: "ania_lightning",
  aniaPrecipitation: "ania_precipitation_75",
  aniaHail: "ania_hail",
  aniaSnow: "ania_snow_30",

  realeGroupHail: "reale_group_hail",
  realeGroupWind: "reale_group_wind",
  howdenWeightedInlandFlood202410: "howden_flood_weighted_202410",

  aniaNat: "ANIA_RINDX_ITA_NE",
  aniaNcat: "ANIA_RINDX_ITA_NCAT",
  cysNat: "cys_rindx_ITA_PC_NE",
  cysNcat: "cys_rindx_ITA_NCAT",

  weatherindex: "cys_risk_weatherindex",

  anyhazard: "not used anyhazard",
  none: "dbb_no_policies", // can be anything, it's not used
};
